class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    // Let CSS transitions handle the animation
    // Don't interfere with getAnimations()
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;
    this.isFirstOpen = true;
    this.setupHoverEvents();
  }

  setupHoverEvents() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const submenu = this.mainDetailsToggle.querySelector('.mega-menu__content');
    
    // Check if we're on desktop
    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
    
    // Open on hover (desktop only)
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      if (isDesktop() && !this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        this.onToggle();
      }
    });

    // Close on mouse leave (with small delay to prevent flickering)
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      if (isDesktop()) {
        this.closeTimeout = setTimeout(() => {
          if (this.mainDetailsToggle.hasAttribute('open')) {
            this.mainDetailsToggle.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
            this.onToggle();
          }
        }, 150);
      }
    });

    // Keep open when hovering over the submenu
    if (submenu) {
      submenu.addEventListener('mouseenter', () => {
        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout);
          this.closeTimeout = null;
        }
      });
      
      submenu.addEventListener('mouseleave', () => {
        if (isDesktop()) {
          this.closeTimeout = setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open')) {
              this.mainDetailsToggle.removeAttribute('open');
              summary.setAttribute('aria-expanded', 'false');
              this.onToggle();
            }
          }, 150);
        }
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
